$(function () {
    $('form').validate().settings.rules["Contact.Phone"].required = "#Contact_Email:blank";
    $('form').validate().settings.rules["Contact.Email"].required = "#Contact_Phone:blank";
    $('form').validate().settings.messages["Contact.Phone"].required = "Please provide either a Phone number or Email address.";
    $('form').validate().settings.messages["Contact.Email"].required = "Please provide either a Phone number or Email address.";

  $('form').submit(function () {
	if (!$("form").valid())
	  return false;

	$("#errors,form input[type=submit]").addClass("hide");
	$(".saving").removeClass("hide");

	$.ajax({
	  url: $(this).attr('action'),
	  type: 'POST',
	  dataType: "json",
	  data: $(this).serialize(),
	  success: function (data) {
		if (data.Status == "OK") {
			window.location.href = successUrl + "?contactId=" + data.ContactId;
		}
		else {
		  $("#errors,form input[type=submit]").removeClass("hide").html(data.Errors);
		}


		$(".saving").addClass("hide");
	  },
	  error: function (jqXHR, textStatus, errorThrown) {
		$("#errors,form input[type=submit]").removeClass("hide").html(jqXHR.responseJSON);
		$(".saving").addClass("hide");
	  }
	});

	return false;
  });
});